import { render } from "./BookingFinal.vue?vue&type=template&id=2ec92736&scoped=true&ts=true"
import script from "./BookingFinal.vue?vue&type=script&lang=ts"
export * from "./BookingFinal.vue?vue&type=script&lang=ts"

import "./BookingFinal.vue?vue&type=style&index=0&id=2ec92736&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec92736"]])

export default __exports__